import React from 'react';
import { Form } from 'src/components/Antd';
import SectionWrapper from 'src/pages/SalesCannelVersion/Components/SectionWrapper';
import ProductTable from 'src/pages/SalesCannelVersion/SalesChannelDiscounts/Components/ProductTable';
//import css from './css.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const Item = Form.Item;
const SubscriptionBuyProducts = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const { selectedProducts, disableEdit } = props;
  return (
    <SectionWrapper
      title={getI18n(
        'salesChannelSubscriptionBuy.product.subscriptionBuyProducts',
      )}
      style={{ paddingBottom: 32 }}>
      <Item
        name={'salesChannelProducts'}
        rules={[
          {
            validator: async (x, value) => {
              if ((value || []).length < 1) {
                return Promise.reject(
                  new Error(
                    getI18n(
                      'salesChannelSubscriptionBuy.product.pleaseSelectatleastoneitem',
                    ),
                  ),
                );
              }
            },
          },
        ]}>
        <ProductTable
          disabledProducts={selectedProducts}
          disableEdit={disableEdit}
        />
      </Item>
    </SectionWrapper>
  );
};
export default SubscriptionBuyProducts;
